import React from "react";
import ReactDOM from "react-dom/client";

import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import Body from "./src/Body";
import Header from "./src/Header";
import RestaurantPage from "./src/RestaurantPage";


const AppLayout = () => {
    return (
        <>
            <Header/>
            <Outlet/>
        </>
    )
}

const appRouter = createBrowserRouter([
    {
        path: '/',
        element: <AppLayout />,
        children: [
            {
                path: '/',
                element: <Body />
            },
            {
                path: '/restaurant/:id',
                element: <RestaurantPage />
            }
        ]
    },
])

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<RouterProvider router={appRouter} />)